import React, { useState, useEffect } from "react";
import Row from "olive-react-myoneui/lib/Row";
import Col from "olive-react-myoneui/lib/Col";
import Card from "olive-react-myoneui/lib/Card";
import DropdownCommon from "../DropdownCommon";
import CourseHoverableListing from "./courseHoverableListing";
import { useSearchParams } from 'react-router-dom';
import { timeZoneList } from "../../../constants/timeZoneList";
import { getCache } from "../../Page/utils/cacheManager";
import { getAllCourses } from "../../../api/initialApis";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { commonModuleName } from "../../../constants/config";
import IaminterestedModal from "../IamInterestedModal";
import { setUserItemApprovalData } from "../../../reducers/userItemApprovalSlice";

function CourseListing({ className }) {
  const { t } = useTranslation(commonModuleName);
  const [allCourses, setAllCourses] = useState(null);
  const miscellaneous = useSelector((state) => state.user.miscellaneous);
  const enrolled = useSelector((state) => state.user.user.logged_in_user.enrolled);
  const showIamInterestedModal = useSelector((state) => state.userItemApproval.showIamInterestedModal);
  const dispatch = useDispatch();

  const paths = useSelector((state) => state.user.paths);
  const loggedInUser = useSelector((state) => state.user.user.logged_in_user);

  useEffect(() => {
    const init = async () => {
      const content = await getCache("all_courses", getAllCourses, {}, 2592000);
      setAllCourses(content);
    }
    init();
  }, []);
  const changeTimeZone = (obj) => {
    localStorage.setItem("selected_timezone", obj.name_without_offset);
    const searchObject = Object.fromEntries([...searchParams]);
    setSearchParams({ ...searchObject });
  }
  const [searchParams, setSearchParams] = useSearchParams();
  const [currentTab, setCurrentTab] = useState(searchParams.get('course_filter'));
  if (!allCourses || miscellaneous.length < 1) {
    return false;
  }
  const selectedTimeZone =  timeZoneList[localStorage.getItem("selected_timezone") ? localStorage.getItem("selected_timezone") : miscellaneous.configured_time_zone];
  const selectedUTCOffset = selectedTimeZone.utc_offset_seconds * 1000; // converting minutes to milli seconds
  return (
    <>
    <Card className={`${className || ""} border-0`}>
      <Card.Body className="p-0 tabs-community courses-categories res-content-order">
        <CourseHoverableListing filter="packages" allCourses={allCourses} offsetDifference={selectedUTCOffset} miscellaneous={miscellaneous} paths={paths} enrolled={enrolled} />
        <Row className="dropdown-pos-1">
          <Col lg={4}>
            <div className="courses-time-dropdown">
              <div> 
                <DropdownCommon defaultValue={selectedTimeZone} items={Object.values(timeZoneList)} label={t('select_timezone')} onChange={(obj) => changeTimeZone(obj)} className="mb-0" />
              </div>
            </div>
          </Col>
        </Row>
      </Card.Body>
      <IaminterestedModal
        show={showIamInterestedModal}
        onHide={() => dispatch(setUserItemApprovalData({showIamInterestedModal : false}))}
        successTitle={"Are you sure want to continue? This will create the interest in this course and line managers must approve your request"}
        successMessage={''}
      />
    </Card>
    </>
  );
}

export default CourseListing;
